import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { datadogRum } from '@datadog/browser-rum';
import { useContext, useEffect } from 'react';
import { ANALYTICS_EVENTS } from '~/constants/flp/analyticsEvents';
import { DATADOG_EVENTS } from '~/constants/flp/datadogEvents';
import { useFinancingContext } from '~/context/flp/FinancingContext';

export default function useTermsUpdated(isLoggedIn: boolean) {
  const { trackEvent } = useContext(AnalyticsContext);
  const { financeTerms, tradeIn, aggregates } = useFinancingContext();

  useEffect(() => {
    if (isLoggedIn) {
      const termsPayload = {
        financeTerms,
        tradeIn,
        aggregates
      };

      datadogRum.addAction(DATADOG_EVENTS.API.TERMS_UPDATED, termsPayload);
      trackEvent(ANALYTICS_EVENTS.PREQUALIFIED.TERMS_UPDATED, termsPayload);
    }
  }, [aggregates, financeTerms, isLoggedIn, tradeIn, trackEvent]);
}
